import React, { useEffect, useState, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import BackToTop from './components/BackToTop';
import ContactModal from './components/ContactModal';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Horoscope from './pages/Horoscope';

const ModalContext = createContext();
export const useContactModal = () => useContext(ModalContext);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <ModalContext.Provider value={{ openContactModal: () => setShowContactModal(true) }}>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/horoscope-2026" element={<Horoscope />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <BackToTop />
        </div>
        <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
      </Router>
    </ModalContext.Provider>
  );
}

export default App;
